import React from 'react';
import styled from 'styled-components';
import { Typography, Card, Grid } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { colors } from 'styles';
import Markdown from 'src/utils/markdownToComponent';
import QuestionCard from './QuestionCard/QuestionCard';

const StyledContainer = styled.div`
  margin-top: 5em;
  background-color: ${colors.shades.grey.light};
  padding: 2em 5em;
  width: 100%;
`;

const PurpleText = styled(Typography)`
  color: ${colors.shades.purple.dark};
  font-weight: bold;

  & span {
    font-weight: normal;
    font-size: 0.9em !important;
  }
`;

const Title = styled(PurpleText)`
  text-align: center;
  margin-bottom: 1em;
`;

const CenteredGrid = styled(Grid)`
  justify-content: center;
`;

const CardContainer = styled(CenteredGrid)`
  /* padding: 0 10em !important; */
`;

const FooterContainer = styled.div`
  text-align: center;
`;

const FAQBlock = ({ data: questions, footer }) => {
  return (
    <StyledContainer>
      <Title variant="h2">
        <FormattedMessage id="pricing.faqBlock.frequentlyAskedQuestions" />
      </Title>
      <CardContainer container spacing={2}>
        {questions.map(question => (
          <CenteredGrid item xs={12} md={5}>
            <QuestionCard question={question} />
          </CenteredGrid>
        ))}
        <FooterContainer>
          <PurpleText variant="body2" dangerouslySetInnerHTML={{__html: footer.html}} />
        </FooterContainer>
      </CardContainer>
    </StyledContainer>
  );
};

export default FAQBlock;
